module.exports = __webpack_public_path__ + "img/footwear.758dd219.svg";